import ApiService, { FileService, CommetService } from "@/base/api/api.service"

import {
    GET_USER_URL
} from "@/base/api/config.js"

import {
    SIGN_UP_USER,
    SIGN_UP_USER_OTHERS,
    SIGN_IN_USER,
    SIGN_OUT_USER,
    SEND_PASSWORD_RESET,
    CHECK_AUTH,
    UPDATE_ACCOUNT,
    ADD_PROFILE_PIC,
    REMOVE_PROFILE_PIC
} from '@/store/actions.type.js'

import {
    SET_AUTH,
    CLEAR_AUTH,
    SET_ACCOUNT_ERROR,
    SET_ERROR,
    SET_USER_LOADING,
    SET_USER_UPDATING,
    SET_UPDATE_ACCOUNT,
    SET_NOTIFICATIONS
} from '@/store/mutations.type.js'

export default {

    // Signing up user action
    [SIGN_UP_USER]({ commit }, payload) {
        commit(SET_USER_LOADING, true)
        ApiService.firebaseCreateUser({
                name: payload.name,
                email: payload.email,
                password: payload.password,
                username: payload.username
            })
            .then((res) => {
                //commit(SET_AUTH, user)
                return CommetService.createUser({
                    uid: res.data.user.firebase_id,
                    name: res.data.user.username
                })

            })
            .then(() => {
                commit(SET_USER_LOADING, false)
                window.location.href = '/account/edit/'
            })
            .catch(error => {
                commit(SET_USER_LOADING, false)
                commit(SET_ACCOUNT_ERROR, error)
            })
    },

    [SIGN_UP_USER_OTHERS]({ commit }, payload) {

        //commit(SET_USER_LOADING, true)
        ApiService.firebaseCreateUserUsingThirdParty({
                type: payload.type
            }).then((res) => {
                if(res.data.exist) return 'exist'
                return CommetService.createUser({
                    uid: res.data.user.firebase_id,
                    name: res.data.user.username
                })
            })
            .then((res) => {
                //commit(SET_USER_LOADING, false)

                res === 'exist' ? window.location.href = '/' : window.location.href = '/account/edit/'
            })
            .catch(error => {
                //commit(SET_USER_LOADING, false)
                commit(SET_ACCOUNT_ERROR, error)
            })
    },

    // Signing in user action
    [SIGN_IN_USER]({ commit }, payload) {
        commit(SET_USER_LOADING, true)
        ApiService.firebaseSigninUser({
                email: payload.email,
                password: payload.password
            })
            .then(() => {
                commit(SET_USER_LOADING, false)
                //commit(SET_AUTH, user)
                window.location.href = '/'

            })
            .catch(error => {
                commit(SET_USER_LOADING, false)
                commit(SET_ACCOUNT_ERROR, error)
            })
    },

    // Signing out user
    [SIGN_OUT_USER]({ commit }) {
        ApiService.firebaseSignout()
            .then(() => {
                ApiService.removeHeader()
                commit(CLEAR_AUTH)
                return CommetService.logOut()
            })
            .then(() => {
                window.location.href = '/'
            })

    },

    // Adding/changing Profile pic
    async [ADD_PROFILE_PIC]({ commit }, file) {
        try {
            const url = await FileService.uploadProfilePic(file)
            return url
        } catch (err) {
            commit(SET_ERROR, err.data)
        }
    },

    // Removing profile pic
    async [REMOVE_PROFILE_PIC]({ commit }, payload) {
        try {
            await FileService.deletProfilePic(payload)
        } catch (err) {
            commit(SET_ERROR, err.data)
        }
    },

    // Updating user
    async [UPDATE_ACCOUNT]({ commit }, payload) {
        commit(SET_USER_UPDATING, true)

        const updatedValues = payload

        try {
            await ApiService.patch(GET_USER_URL, updatedValues)
            commit(SET_USER_UPDATING, false)
            commit(SET_UPDATE_ACCOUNT, {
                value: updatedValues
            })
            commit(SET_NOTIFICATIONS, {
                message: 'Account updated'
            })
        } catch (err) {
            commit(SET_USER_UPDATING, false)
            commit(SET_ERROR, err.data)
        }
    },

    // Checking auth
    async [CHECK_AUTH]({ commit }) {
        commit(SET_USER_LOADING, true)
        try {
            const res = await ApiService.firebaseCheckAuth()
            commit(SET_USER_LOADING, false)
            commit(SET_AUTH, res.data.user)

            CommetService.loginUser({
                uid: res.data.user.firebase_id
            })

            // Calling user request after await so to not block the other requests, for just getting user details
            // ApiService.get('/' + GET_USER_URL)
            // .then(res => {
            //     commit(SET_USER_LOADING, false)
            //     commit(SET_AUTH, res.data.user)
            // })
        } catch (err) {
            commit(SET_USER_LOADING, false)
            if (err.message !== "Null User") commit(SET_ACCOUNT_ERROR, err)
        }
    },

    // Reset pass accounts
    async [SEND_PASSWORD_RESET]({ commit }, payload) {
        try {
            await ApiService.firebaseResetPassword({
                email: payload.email
            })
        } catch (err) {
            commit(SET_ACCOUNT_ERROR, err)
        }
    }
}